module.exports = __webpack_public_path__ + "img/icn_customers.d7a85e4f.svg";